module.exports = __webpack_public_path__ + "img/TATAR.316feed4.png";